<template>
    <v-container fluid v-if="verified" class="px-0">
        <TopNavigation/>
        <!-- <InstallToDevice /> -->
        <LoadingSpinner v-if="loading"/>
        <br>
        <v-main v-if="loaded" v-show="!loading" class="ma-4">
            <v-row row wrap align="center" dense no-gutters>
                <v-col cols="12" md="8" sm="8" offset-sm="2" offset-md="2" lg="6" offset-lg="3">
                    <FailedSubscriptionNotification/>
                    <v-card
                            :class="{'mt-3': $vuetify.breakpoint.smAndUp}"
                            :elevation="cardElevation"
                            :flat="cardFlat"
                    >
                        <v-container
                                :class="{'pa-3': $vuetify.breakpoint.smAndDown}"
                        >
                            <router-view></router-view>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-main>

        <NotificationSnackbar/>

    </v-container>
</template>

<script>
import InstallToDevice from '_GLOBAL/components/InstallToDevice';
import { mapGetters } from 'vuex';
import TopNavigation from '../components/Global/Navigation/TopNavigation';
import ProfileList from '../components/Profile/ProfileList';

import LoadingSpinner from '../components/Global/LoadingSpinner';
import NotificationSnackbar from '../components/Global/Notifications/NotificationSnackbar';


import FailedSubscriptionNotification from '../components/Global/Notifications/FailedSubscriptionNotification.vue';

export default {
  name: 'ParentAppLayout',
  components: {
    FailedSubscriptionNotification,
    TopNavigation,
    LoadingSpinner,
    NotificationSnackbar,
    ProfileList,
    InstallToDevice,
  },

  methods: {},
  computed: {
    ...mapGetters(['globalLoading', 'verified', 'savedCards', 'darkMode']),
    cardElevation() {
      // if (this.$vuetify.breakpoint.smAndDown) {
      //   return 0;
      // }
      return 3;
    },
    cardFlat() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return true;
      }
      return false;
    },

    loading() {
      return this.globalLoading;
    },
    loaded() {
      return 'personId' in this.$store.getters.parent;
    },
  },

  async beforeCreate() {
    const root = await document.getElementById('parentDashboard');
    this.$store.commit(
      'UPDATE_STRIPE_PUBLIC_KEY',
      root.dataset.stripePublicKey,
    );
  },

  async created() {
    this.$store.dispatch('GET_CLIENT_LOGOS_URL');
    // this.$store.dispatch('GET_OUTSTANDING_SUBSCRIPTION_INVOICES');
    await this.$store.dispatch('GET_PARENT');
  },
  updated() {
  },
};
</script>
